module.exports = __webpack_public_path__ + "img/cooling-effect.de25f45.svg";